import { useCurrentFullLocale } from "common/utils/locale";
import { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { useHomeContextUser } from "routes/home/homeContext";

type GTMVariable = Record<string, unknown>;

const createScriptContent = (variables: GTMVariable): string => {
  return Object.entries(variables)
    .map(([key, value]) => `${key} = ${JSON.stringify(value)};`)
    .join("\n");
};

const GoogleTagManagerVariables = () => {
  const locale = useCurrentFullLocale();
  const { email: userEmail } = useHomeContextUser();

  const variables = useMemo(
    (): GTMVariable => ({
      locale,
      userEmail,
    }),
    [locale, userEmail]
  );

  const scriptContent = useMemo(
    () => createScriptContent(variables),
    [variables]
  );

  return (
    <Helmet>
      <script type="text/javascript">{scriptContent}</script>
    </Helmet>
  );
};

export default GoogleTagManagerVariables;
